import * as _ from 'lodash';
import { formatDate } from 'utils/date';


/*
  filter: {
    data?: {attributeName, ...}, // attributes filter
    title?: string, // simple title filter
  }
*/
export const getFilterTitle = (filter: any): string => {
  if (!_.get(filter, 'data.attributeName') && _.get(filter, 'title')) {
    return filter.title;
  }

  const data = _.get(filter, 'data', {});
  let title = _.get(data, 'attributeName', filter.title);

  if (data.checkNullValue && !(data.nestedAttributes && data.nestedAttributes.length)) {
    // IS NULL
    if (data.attribute.is_text_select && data.selectValue) {
      const option: any = _.find(data.selectData, {option: data.selectValue});
      if (option) {
        title = option.title;
      }
    }
    title = `No ${title}`;
  } else if (data.textValue !== null && data.textValue !== undefined) {
    // TEXT ATTRIBUTE
    title = data.textValue;
  } else if (data.nestedAttributes && data.nestedAttributes.length) {
    // WITH NESTED ATTRIBUTES
    const filledField = _.find(data.nestedAttributes, (item: any) => {
      return item.selectValue !== null;
    });
    // 'is null' and no selected field
    if (data.checkNullValue && !filledField) {
      title = `No ${title}`;
    } else {
      title = _.reduce(data.nestedAttributes, (result: string, nestedAttribute: any, index: number) => {
        let selectTitle;
        const attributeTitle = nestedAttribute.attribute.column_title ?
          nestedAttribute.attribute.column_title : nestedAttribute.attribute.title;

        if (!nestedAttribute.selectValue) {
          if (data.checkNullValue && index > 0) {
            selectTitle = `No ${attributeTitle}`;
          } else {
            return result;
          }
        } else {
          if (data.checkNullValue && index === data.nestedAttributes.length - 1) {
            selectTitle = `No ${attributeTitle}`;
          } else {
            const option = _.find(nestedAttribute.selectData, (item: any) => {
              return String(item.option) === String(nestedAttribute.selectValue);
            });
            selectTitle =  _.get(option, 'title', '');
          }
        }
        return result.length ? `${result}, ${selectTitle}` : `${selectTitle}`;
      }, '');
    }
  } else if (data.selectValue !== null && data.selectValue !== undefined) {
    // SELECT ATTRIBUTE
    // https://speedlab.atlassian.net/browse/SPD2-2324
    let prefix = '';
    switch (data.attributeOption) {
      case 'msdsRequired':
        prefix = 'MSDS: ';
        break;
      case 'acesApplication':
        prefix = 'ACES: ';
        break;
      default:
        break;
    }
    if (data.selectData !== null) {
      title = _.get(_.find(data.selectData, (item: any) => {
        return String(item.option) === String(data.selectValue);
      }), 'title', '');
    } else {
      title = data.selectValue;
    }
    title = `${prefix}${title}`;
  } else if ((data.dateFromValue !== null && data.dateFromValue !== undefined) ||
    (data.dateToValue !== null && data.dateToValue !== undefined)) {
    // DATEPICKER ATTRIBUTE
    switch (data.attributeOption) {
      case 'createdDate':
        title = 'Created';
        break;
      case 'modifiedDate':
        title = 'Modified';
        break;
      case 'publishedDate':
        title = 'Published';
        break;
      default:
        break;
    }
    if (data.dateFromValue !== null && data.dateFromValue !== undefined) {
      const fromFormatted = formatDate(data.dateFromValue);
      if (data.dateToValue) {
        const toFormatted = formatDate(data.dateToValue, true, new Date(), false);
        title += ` ${fromFormatted} - ${toFormatted}`;
      } else {
        title += ` since ${fromFormatted}`;
      }
    } else if (data.dateToValue !== null && data.dateToValue !== undefined) {
      const toFormatted = formatDate(data.dateToValue, true, new Date(), false);
      title += ` before ${toFormatted}`;
    }
  }
  return title;
};

export const getFilterLabel = (filter: any): string => {
  return _.get(filter, 'data.attributeInfo.title_column_name');
};
